import api from "../security/api";

const viewWebFindAll = (client) => {
    return api
        .get(`web/findAll?client=${client}`);
};

const webService = {
    viewWebFindAll
};


export default webService;
